export var TwoFaEnum;
(function (TwoFaEnum) {
    TwoFaEnum["SMS_2FA"] = "SMS_2FA";
    TwoFaEnum["GOOGLE_2FA"] = "GOOGLE_2FA";
    TwoFaEnum["EMAIL_2FA"] = "EMAIL_2FA";
})(TwoFaEnum || (TwoFaEnum = {}));
//# sourceMappingURL=two-fa.enum.js.map